export const IMPLEMENTED_STAGE_IDS = [
  'stage_targeting_strategist',
  'stage_1a_keywords',
  'stage_1b_semrush',
  'stage_2a_serp_overview',
  'stage_2b_competitor_plan',
  'stage_2c_competitor_extract',
  'stage_2d_competitor_aggregate',
  'stage_2e_internal_links',
  'stage_3a_brief',
  'stage_4a_research_enrichment',
  'stage_4b_section_drafting',
  'stage_4c_research_finalize',
  'stage_5_cta_placement',
  'stage_6_seo_validation',
  'stage_7_image_generation',
  'stage_7c_final_polish',
  'stage_8_wp_publish',
  'stage_9_ai_queries',
  'stage_10_confirmed_published',
] as const;

export const DISABLED_STAGE_IDS = [
  'stage_8_assembly',
] as const;

/** Omitted from pipeline / stage sidebars. */
export const HIDDEN_FROM_UI_STAGE_IDS = [] as const;

export type PipelineStageLike<TPrompt = any> = {
  id: string;
  name?: string;
  order?: number | null;
  prompt?: TPrompt;
};

export const sortPipelineStages = <T extends { order?: number | null }>(stages: T[]) => {
  return [...stages].sort((a, b) => (a.order ?? 9999) - (b.order ?? 9999));
};

export const buildStageNameMap = <T extends { id: string; name?: string }>(stages: T[]) => {
  return new Map(stages.map((stage) => [stage.id, stage.name || stage.id]));
};

export const buildStagePromptMap = <TPrompt>(stages: Array<PipelineStageLike<TPrompt>>) => {
  return stages.reduce<Record<string, TPrompt | undefined>>((acc, stage) => {
    acc[stage.id] = stage.prompt;
    return acc;
  }, {});
};

export const getResolvedStagePrompt = <TPrompt>(
  stageId: string,
  promptMap: Record<string, TPrompt | undefined>,
  promptInstances?: Record<string, TPrompt> | null
) => {
  if (promptInstances && promptInstances[stageId]) {
    return promptInstances[stageId];
  }
  return promptMap[stageId];
};

export const isImplementedStageId = (stageId?: string | null) =>
  Boolean(stageId && IMPLEMENTED_STAGE_IDS.includes(stageId as typeof IMPLEMENTED_STAGE_IDS[number]));

export const isDisabledStageId = (stageId?: string | null) =>
  Boolean(stageId && DISABLED_STAGE_IDS.includes(stageId as typeof DISABLED_STAGE_IDS[number]));
